<template>
    <base-filter
        :status-options="statuses"
        :date-mode="'single'"
        :show-team-members="true"
        :show-carriers="false"
        :show-customer-filter="true"
        :clearable="false"
        :date-clearable="false"
        :use-in-map="true"
        :team-region-id="teamRegionId"
        :initial-filters="initialFilters"
        :status-test-id="'trip-status'"
        :single-date-test-id="'trip-date'"
        :single-date-class="'datepicker-container'"
        :default-status="'All Statuses'"
        domain="trips"
        @onFilterTrips="handleFilterTrips"
    ></base-filter>
</template>
<script>
import { BaseFilter } from '@/components';
import { TRIP_STATUS_CONSTANTS } from '@/utils/constants';
import moment from 'moment';

export default {
    name: 'TripFilterComponent',
    components: { BaseFilter },
    props: {
        tripDate: {
            type: String,
            default: ''
        },
        teamRegionId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            statuses: ['All Statuses', ...TRIP_STATUS_CONSTANTS],
            initialFilters: {
                status: 'All Statuses',
                singleDate: this.tripDate || moment().format('YYYY-MM-DD'),
                teamMemberPublicUserId: '',
                teamRegionId: null
            }
        };
    },
    watch: {
        tripDate: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.initialFilters = {
                        ...this.initialFilters,
                        singleDate: newVal
                    };
                }
            }
        }
    },
    methods: {
        handleFilterTrips(payload) {
            this.$emit('onFilterTrips', payload);
        }
    }
};
</script>

<style lang="scss" scoped>
.filter-steps--container {
    flex-grow: 2;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // Consistent width for all fields
    ::v-deep .md-field,
    ::v-deep .filter-item {
        width: 200px;
        margin-right: 20px;
        margin-top: 0;
        flex: 0 0 200px;
    }
    // Reorder fields to match original layout:
    // Original: Row 1: Team Region, Team Member, Date | Row 2: Status, Customer
    // BaseFilter order: Team Region/Member, Customer, Status, Date
    // Need to reorder: Team Region/Member (1), Date (2), Status (3), Customer (4)
    // And force Status to start on new row

    ::v-deep .team-region-member-filter-options {
        order: 1;
    }

    ::v-deep .datepicker-container {
        order: 2;
    }
    // Status filter - target md-field that's not the date picker
    // Force it to start on a new row with flex-basis: 100%, then constrain width back to 200px
    ::v-deep .md-field:not(.datepicker-container):not(.time-picker) {
        order: 3;
        flex-basis: 100%;
        max-width: 200px;
        flex: 0 0 auto;
        width: 200px;
    }
    // Customer filter - target filter-item that contains customer-filter-options
    ::v-deep .filter-item:not(.filter-item--checkbox) {
        order: 4;
    }
    // Domain-specific label for single date field
    .datepicker-container ::v-deep .md-datepicker:before,
    .datepicker-container ::v-deep .md-datepicker:after {
        content: 'Trip date';
    }
    // Hide clear button to ensure date is always present
    .datepicker-container ::v-deep .md-clear {
        display: none;
    }
}
</style>
